import type { GlbSceneConfig } from '../glb/glbSceneConfig';
import { resolveCdnUrl } from '../../utils/cdnUrl';

export const goldenSpoutSceneConfig: GlbSceneConfig = {
  id: 'golden-spout-scene',
  bgTheme: 'black',
  renderer: {
    maxPixelRatio: 2,
  },
  camera: {
    fov: 60,
    near: 0.01,
    far: 100,
    initialPosition: {"x":-6.4221,"y":-4.0114,"z":14.2467},
    initialTarget: { x: -0.1021, y: -0.0969, z: 1.7983 },
  },
  controls: {
    target: { x: -0.1021, y: -0.0969, z: 1.7983 },
    minDistance: 5,
    maxDistance: 20,
    enablePan: false,
    enableDamping: true,
    dampingFactor: 0.08,
  },
  models: [
    {
      key: 'golden-spout-scene',
      url: resolveCdnUrl('models/poi-artifacts/spout_matalic.glb'),
    },
  ],
  environment: {
    hemisphereLight: {
      skyColor: 0xffffff,
      groundColor: 0x444444,
      intensity: 0.8,
    },
    directionalLights: [
      {
        color: 0xffffff,
        intensity: 1.2,
        position: { x: 2, y: 3, z: 2 },
      },
      {
        color: 0xffd700,
        intensity: 0.4,
        position: { x: -1, y: 1, z: -2 },
      },
    ],
  },
  collision: {
    cameraRadius: 0.3,
  },
};
